function Filter() {
  return {
    active: false,
    activeOption: 'all',
    handleFilterUpdate({ detail }) {
      const { option } = detail;
      this.activeOption = option.slug;
      this.active = false;
    },
  };
}

export default Filter;
